import {Controller} from '@hotwired/stimulus';

const availableSliderControllers = [];

export default class extends Controller {

    static get targets() {
        return ['slider', 'thumbs'];
    }

    async connect() {
        availableSliderControllers.push(this);
        const element = this.element;
        let slider = this.targets.find('slider');
        const useThumbs = this.targets.find('thumbs');
        if (!slider) {
            slider = element;
        }

        import('swiper').then(Swiper => {
            import('swiper/modules').then(SwiperModules => {
                const {Navigation, Pagination, Autoplay, Thumbs, EffectFade} = SwiperModules;
                const additionalConfig = slider.dataset.swiper ? JSON.parse(slider.dataset.swiper) : {};
                // Config https://swiperjs.com/swiper-api
                const config = {
                    spaceBetween: 0,
                    modules: [Navigation, Pagination, Autoplay, Thumbs],
                    ...additionalConfig,
                };
                let thumbsSwiper;
                if (useThumbs) {
                    const additionalConfig2 = useThumbs.dataset.swiper ? JSON.parse(useThumbs.dataset.swiper) : {};
                    const config2 = {
                        spaceBetween: 0,
                        modules: [Navigation, Thumbs, EffectFade],
                        ...additionalConfig2,
                    };
                    thumbsSwiper = new Swiper.default(useThumbs, config2);
                    config['thumbs']['swiper'] = thumbsSwiper;
                }

                if ('customPagination' in config && 'customPaginationItems' in config) {
                    config['pagination']['renderBullet'] = function (index, className) {
                        return `<span class="${className}">${config['customPaginationItems'][index]}</span>`;
                    };
                }

                if ('initBreakpoint' in config) {
                    if (window.innerWidth <= config['initBreakpoint']) {
                        this.swiper = new Swiper.default(slider, config);
                    }
                    window.addEventListener('resize', () => {
                        if (window.innerWidth <= config['initBreakpoint']) {
                            if (!this.swiper) {
                                this.swiper = new Swiper.default(slider, config);
                            }
                        } else if (this.swiper) {
                            this.swiper.destroy();
                            this.swiper = null;
                        }
                    })
                } else {
                    this.swiper = new Swiper.default(slider, config);
                }

                if ('onClickFocus' in config) {
                    this.swiper.on('click', (swiper, event) => {
                        swiper.slideTo(swiper.clickedIndex);
                    });
                }

                if ('autoplay' in config) {
                    slider.addEventListener('mouseenter', () => {
                        this.swiper.autoplay.pause();
                        this.swiper.translateTo(this.swiper.getTranslate(), 1, true, true);
                    });
                    slider.addEventListener('mouseleave', () => {
                        this.swiper.autoplay.start();
                    });
                }
            });
        });
    }
}
